import StorageService from 'services/StorageService';
import UserInfoService from 'services/AccountInfo/';
import NewRelicService from 'services/NewRelic'
import CartAction from 'actions/Cart';
import AddressService from "services/Address";
import { methodToSla, newCheckout } from 'config';
import DeliverySelectorService from 'services/DeliverySelector';
import CartService from "services/Cart";
import SalesChannel from 'services/SalesChannel';
import WalletService from 'services/Wallet'
import {paymentsName, walletPaymentsName, paymentsId} from "config/index";
import CartFactory from 'factories/Cart';
import CmsService from 'services/CMS';
import { defaultSC, ecommerce } from 'config/constants';

const initialOrderForm = (orderForm) => {
    let promise = null;
    if (!orderForm?.clientProfileData) {
        promise = _applyProfileData();
    } else {
        promise = Promise.resolve(true);
    }
    return promise.then(() => {
        let address = StorageService.getSecureItem('address');
        const methodFromStorage = StorageService.getItem('preselected_shipping_method');
        const nameMethod = methodToSla[methodFromStorage];

        if(validationShippingData(orderForm, nameMethod, methodFromStorage, address)) return Promise.resolve(true);
        return _getSC(methodFromStorage, address).then(deliveryType => {
            
            if (deliveryType) {
                let sc = ecommerce.whiteLabel ? defaultSC : deliveryType.sc;
                let name = null;
                let coordinates = null;
                let seller = ecommerce.whiteLabel ? deliveryType.seller : null;

                if(methodFromStorage === 'seller-1-sla-DespachoaDomicilio'){
                    name = address.neighborhood;
                    address.geoCoordinates = address.geoCoordinate; 
                } else {
                    name = deliveryType.value;
                    address = false;
                    if(deliveryType.coordinates){
                        coordinates = deliveryType.coordinates.split(',').reverse();
                        if(coordinates.length) coordinates = coordinates.map(coordinate => parseFloat(coordinate));
                        seller = deliveryType.seller;
                    }
                }
        
                return DeliverySelectorService._applyDelivery(sc, methodFromStorage, name, nameMethod, address, true, seller, coordinates, true, true).then(response => {
                    let _orderForm = response.orderForm;

                    let seller = SalesChannel.getSeller();
                    let addressId = nameMethod;
                    let sla =  CartService.getSlasOF(_orderForm, seller, addressId);
                    let windows = sortDate(sla[0].availableDeliveryWindows);
                    let firstWindow = windows[0];
                    StorageService.setItem('firstWindowAvailable', JSON.stringify(firstWindow))

                    let logisticsInfo = _orderForm.shippingData.logisticsInfo;
                    let addressOrderForm = _orderForm.shippingData.address;

                    return Promise.all([applyDeliveryWindow(logisticsInfo, addressOrderForm, firstWindow, methodFromStorage)]).then((response) => {
                        return response;
                    })

                })
            }
            return false;
        });
    }).catch(()=> {
        orderForm.error = true;
        return orderForm;
    })
}

const applyDeliveryWindow = (logisticsInfo, addressOrderForm, firstWindow, methodFromStorage) => {
    let newLogisticsInfo = CartFactory.setSlaDeliveryWindow(logisticsInfo, firstWindow, methodFromStorage, null, true);
    return CartAction.updateShippingData(addressOrderForm ,newLogisticsInfo).catch(() => false);
}


const _applyProfileData = () => {
    return UserInfoService.getUser().then(results => {
        let userInfo = results;

        if (userInfo.homePhone && userInfo.document) {

            let updateUser = {
                email: userInfo.email,
                firstName: userInfo.firstName,
                lastName: userInfo.lastName,
                document: userInfo.document,
                documentType: "RUT",
                phone: userInfo.homePhone,
                corporateName: null,
                tradeName: null,
                corporateDocument: null,
                stateInscription: null,
                corporatePhone: null,
                isCorporate: false,
                profileCompleteOnLoading: false,
                profileErrorOnLoading: false,
                customerClass: null
            }
            NewRelicService.sendPageAction({
                action: 'updateClientSubmit',
                payload: {
                    status: 'success'
                }
            });
            return CartAction.setProfileData(updateUser)
        }
        return false;
    }).catch(() => {
        return false;
    })
}

const initPaymentData = (orderForm) => {

    if (orderForm) {
        return WalletService.getWalletCards().then((cards) => {
            let allCards = cards.results.filter((_card) => _card.isFavorite);
            let defaultCard = null;
            if (allCards.length) {
                defaultCard = allCards[0];
            }
            
            WalletService.selectCard(defaultCard);
            if (orderForm.paymentData && orderForm.paymentData?.payments?.length && orderForm.paymentData.payments[0]) {
                orderForm.card = defaultCard;
                return Promise.resolve(orderForm);
            }
            
            let idPayment = paymentsId.oneClick
            const system = orderForm.paymentData.paymentSystems
            const namePaymentTcenco = paymentsName.catOneClick
            const namePaymentOneClick = paymentsName.oneClick
            const idCreditCard = walletPaymentsName.oneClick
            const idTcenco = walletPaymentsName.catOneClick
            
            if (defaultCard.paymentMethod === idCreditCard) {
                const paySelected = system.filter((payment) => payment.name === namePaymentOneClick)
                idPayment = paySelected.length ? paySelected[0].id : paymentsId.oneClick
            } else if (defaultCard.paymentMethod === idTcenco) {
                const paySelected = system.filter((payment) => payment.name === namePaymentTcenco)
                idPayment = paySelected && paySelected.length ? paySelected[0].id : paymentsId.oneClick
            } else if (defaultCard.paymentMethod === walletPaymentsName.debitOneClick) {
                const paySelected = system.filter((payment) => payment.name === paymentsName.debitOneClick)
                idPayment = paySelected.length ? paySelected[0].id : paymentsId.debitOneClick
            }
            const paymentSystems = system.filter((item) => parseInt(item.id) === parseInt(idPayment))[0]
            const installmentOptions = orderForm.paymentData.installmentOptions.filter(
                (item) => parseInt(item.paymentSystem) === parseInt(idPayment)
            )[0]

            if (paymentSystems && installmentOptions) {
                const dataPayment = [
                    {
                        group: paymentSystems.groupName,
                        installments: installmentOptions.installments.length ? installmentOptions.installments[0].count : 1,
                        installmentsInterestRate: installmentOptions.installments.length
                            ? installmentOptions.installments[0].interestRate
                            : 0,
                        paymentSystem: paymentSystems.id,
                        installmentsValue: installmentOptions.installments.length
                            ? installmentOptions.installments[0].total
                            : installmentOptions.value,
                        paymentSystemName: paymentSystems.name,
                        referenceValue: installmentOptions.installments.length
                            ? installmentOptions.installments[0].value
                            : installmentOptions.value,
                        value: installmentOptions.installments.length
                            ? installmentOptions.installments[0].total
                            : installmentOptions.value,
                    },
                ]
                return CartAction.setPayment(dataPayment).then((result)=> {
                    result.card = defaultCard;
                    return result;
                })
            } else {
                return Promise.resolve(false)
            }
        }).catch(() => {
            return false;
        })
    } else {
        return Promise.resolve(false)
    }
    
}

const validationShippingData = (orderForm, sla, method, address) => {
    let validMethod = (method == 'seller-1-sla-DespachoaDomicilio' && (sla == 'Despacho a Domicilio' || sla == 'Despacho a Especial'))
    if(!validMethod){
        validMethod = (method == 'seller-1-sla-RetiroenTienda' && sla == 'Retiro en Tienda')
    }
    if(!validMethod){
        validMethod = (method == 'seller-1-sla-ClickalAuto' && sla == 'Click al Auto')
    }
    const shippingData = orderForm?.shippingData;
    const validAddress = (shippingData?.address?.addressId === address.addressId);
    const logisticsInfo = orderForm?.shippingData?.logisticsInfo[0];
    const validSla = (logisticsInfo?.selectedSla?.includes(sla));
    const slas = logisticsInfo?.slas?.filter((_sla) => _sla?.id?.includes(sla));
    let validWindows = (slas?.length && slas[0]?.deliveryWindow);

    if(validWindows && slas?.length && slas[0].availableDeliveryWindows[0].startDateUtc !== validWindows.startDateUtc){
        validWindows = null
    }
    return !!(validAddress && validSla && validWindows && validMethod);
}

const _getSC = (method, address) => {

    if(method === 'seller-1-sla-DespachoaDomicilio'){
        if(ecommerce.whiteLabel) {
            const consults = [CmsService.getOperationsV2(), AddressService.getSeller(address.geoCoordinate[1], address.geoCoordinate[0])]
            return Promise.all(consults).then((response)=> {
                const stores = response[0]?.store;
                const geolocation = response[1];
                address.geoCoordinates = address.geoCoordinate;
                let sellerSelected = null;
                if(geolocation && geolocation.warehouseId){
                    sellerSelected = stores ? stores.filter(store => store.warehouse_id === geolocation.warehouseId) : null;
                    if(sellerSelected && sellerSelected.length){
                        sellerSelected = sellerSelected[0].seller;
                    }
                }
                return {
                    address,
                    seller: sellerSelected
                }
            });
        } else {
            return AddressService.getSalesChannel(address.geoCoordinate[1], address.geoCoordinate[0]);
        }
    }else{
        return CmsService.getOperationsV2().then((data)=>{
            if (data){
                let stores = data.store ? data.store.filter(store => store.active) : [];
                let storeNameSelected = StorageService.getItem('store_name');
                let storeSelected = stores.filter(store => store.value === storeNameSelected);

                return storeSelected ? storeSelected[0] : false
            }
            return false
        })
    }
}

const setReceiverData = (orderForm, receiverData) => {
    if((receiverData && receiverData.document) || !orderForm.clientProfileData) return Promise.resolve(false);

    const userDataOF = {
        document: orderForm?.clientProfileData?.document,
        firstName: orderForm?.clientProfileData?.firstName,
        lastName: orderForm?.clientProfileData?.lastName
    }

    return CartAction.setUserReceiver(userDataOF);
}

const sortDate = (daysDelivery) => {
    return daysDelivery.sort((a, b) => {
        a = new Date(a.endDateUtc).getTime();
        b = new Date(b.endDateUtc).getTime();
        return a < b ? -1 : a > b ? 1 : 0;
    });
}

const goToCheckout = (step, history) => {
    StorageService.setItem('checkout-step', step)
    if(!history) return '';
    if(newCheckout){
        if(step == 1){
            history.push(`/new-checkout/identification`);
        }
        if(step == 2){
            history.push(`/new-checkout/delivery`);
        }
        if(step == 3){
            history.push(`/new-checkout/payment`);
        }
    }else{
        history.push(`/checkout`);
    }
}

const QuickPurchaseService = {
    
    initialOrderForm,
    initPaymentData,
    goToCheckout,
    setReceiverData,
    applyDeliveryWindow

};

export default QuickPurchaseService;